import { useState, useEffect } from "react";
import cn from "classnames";
import { useTranslation } from "next-i18next";
import differenceInMilliseconds from "date-fns/differenceInMilliseconds";
import s from "./Countdown.module.scss";
import parseISO from "date-fns/parseISO";
import scssVars from 'styles/variables.module.scss';

const Countdown = ({
  className,
  timestamp = 0,
  dateTo = new Date().toISOString().slice(0, 10),
  seconds = true,
  minutes = true,
  hours = true,
  days = true,
  size = 0,
  color = scssVars.redColor,
}) => {
  const { t } = useTranslation();

  const [timeLeft, setTimeLeft] = useState({});

  // if (typeof dateTo === "string") {
  //   console.log("!!Countdown dateTo is string", dateTo);
  // }

  const calculateTimeLeft = () => {
    // let difference =
    //   (timestamp || getTime(new Date(dateTo?.replace(/-/g, '/')))) -
    //   getTime(new Date());

    const _dateTo = typeof dateTo === "string" ? parseISO(dateTo) : dateTo;

    const difference = differenceInMilliseconds(
      timestamp || _dateTo,
      new Date()
    );

    let timeLeft = {};

    if (difference > 0) {
      if (days) {
        timeLeft.days = Math.floor(difference / (1000 * 60 * 60 * 24));
      }

      if (hours) {
        timeLeft.hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      }

      if (minutes) {
        timeLeft.minutes = Math.floor((difference / 1000 / 60) % 60);
      }

      if (seconds) {
        timeLeft.seconds = Math.floor((difference / 1000) % 60);
      }

      // timeLeft = {
      //   ...(days
      //     ? {
      //         days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      //       }
      //     : {}),
      //   ...(hours
      //     ? {
      //         hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      //       }
      //     : {}),
      //   ...(minutes
      //     ? {
      //         minutes: Math.floor((difference / 1000 / 60) % 60),
      //       }
      //     : {}),
      //   ...(seconds
      //     ? {
      //         seconds: Math.floor((difference / 1000) % 60),
      //       }
      //     : {}),
      // };
    }

    setTimeLeft(timeLeft);
  };

  const intervals = Object.keys(timeLeft || []);

  useEffect(() => {
    if (timestamp || dateTo) {
      calculateTimeLeft();

      const timer = setInterval(() => {
        calculateTimeLeft();
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [timestamp, dateTo]);

  // const timerComponents = [];

  // Object.keys(timeLeft).forEach(interval => {
  //   if (!timeLeft[interval]) return
  //   timerComponents.push(interval);
  // });

  return (
    <div className={cn(s.countdown, s[`s${size}`], className)}>
      {!!intervals.length && (
        <>
          <div className={s.numbers}>
            {intervals.map((interval) => (
              <div className={cn(s.number, [interval])} key={interval} style={{ color }}>
                {timeLeft[interval]}
              </div>
            ))}
          </div>
          <div className={s.text}>
            {intervals.map((interval) => (
              <div className={s[interval]} key={interval}>
                {t(interval)}
                {/* {timeLeft[interval] > 1 ? (
                  interval
                  ) : (
                  interval.slice(0, -1)
                )} */}
              </div>
            ))}
          </div>
        </>
      )}
      {/* <span>{t("Time's up!")}</span> */}
    </div>
  );
};

export default Countdown;
